import { GridColDef } from "@mui/x-data-grid";

import { routes } from '@carcareers/utils';
import { DataGridLink } from '@carcareers/components';

export const RESUME_INDEX_COLUMNS: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'idLink',
    headerName: 'View',
    width: 90,
    renderCell: (params) => (
      <DataGridLink
        link={`/${routes.ADMIN_HOME}/${routes.ADMIN_RESUMES_VIEW.replace(':id', params.row.id.toString())}`}
        content={params.row.id}
      />
    ),
  },
  {
    field: 'jobseeker',
    headerName: 'Candidate',
    width: 200,
    valueGetter: (_, row) =>
      row.jobseeker?.user ? `${row.jobseeker.user.firstName} ${row.jobseeker.user.lastName}` : '-',
  },
  { 
    field: 'filename', 
    headerName: 'Filename', 
    width: 200,
    renderCell: (params) => (
      <DataGridLink
        link={`/${routes.ADMIN_HOME}/${routes.ADMIN_RESUMES_VIEW.replace(':id', params.row.id.toString())}`}
        content={params.row.filename?.replace('resumes/', '') || '-'}
      />
    ),
  },
  { field: 'type', headerName: 'Type', width: 100 },
  {
    field: 'createdAt',
    headerName: 'Uploaded',
    width: 150,
    valueGetter: (_, row) =>
      new Date(row.createdAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
  },
  {
    field: 'updatedAt',
    headerName: 'Updated',
    width: 150,
    valueGetter: (_, row) =>
      new Date(row.updatedAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
  },
];

export const RESUME_ADMIN_INDEX_COLUMNS: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'filename',
    headerName: 'Resume File',
    width: 250,
    renderCell: (params) => {
      return (
        <DataGridLink
          link={`/${routes.ADMIN_HOME}/${routes.ADMIN_RESUMES_VIEW.replace(':id', params.row.id.toString())}`}
          content={params.row.filename?.replace('resumes/', '') || '-'}
        />
      );
    },
  },
  {
    field: 'jobseeker',
    headerName: 'Candidate',
    width: 200,
    renderCell: (params) => {
      const name = params.row.jobseeker?.user 
        ? `${params.row.jobseeker.user.firstName} ${params.row.jobseeker.user.lastName}`
        : 'No Jobseeker';
      
      if (params.row.jobseeker?.id) {
        return (
          <DataGridLink
            link={`/${routes.ADMIN_HOME}/${routes.ADMIN_JOBSEEKERS_VIEW.replace(':id', params.row.jobseeker.id.toString())}`}
            content={name}
          />
        );
      }
      return <span>{name}</span>;
    },
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 200,
    valueGetter: (_, row) => row.jobseeker?.user?.email || 'N/A',
  },
  {
    field: 'type',
    headerName: 'File Type',
    width: 150,
    valueGetter: (_, row) => row.type || 'Unknown',
  },
  {
    field: 'createdAt',
    headerName: 'Uploaded',
    width: 150,
    valueGetter: (_, row) =>
      new Date(row.createdAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
  },
];

export const RESUME_INDEX_COLUMN_INITIAL_STATE = {
  id: true,
  jobseeker: true,
  filename: true,
  type: true,
  createdAt: true,
  updatedAt: false,
};

export const RESUME_ADMIN_INDEX_COLUMN_INITIAL_STATE = {
  id: true,
  filename: true,
  jobseeker: true,
  email: true,
  type: true,
  createdAt: true,
};